import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MinhasResponsabilidadesService extends BaseService<{}> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/minhas-responsabilidades';
  }
}
